
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"52","height":"52","viewBox":"0 0 52 52","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M24.4389 3.5C29.1719 3.524 33.6609 5.116 37.3399 8H30.9999C30.4479 8 29.9999 8.447 29.9999 9C29.9999 9.553 30.4479 10 30.9999 10H39.9999C40.1299 10 40.2599 9.973 40.3819 9.923C40.6269 9.822 40.8219 9.627 40.9229 9.382C40.9729 9.26 40.9999 9.13 40.9999 9V1C40.9999 0.447 40.5519 0 39.9999 0C39.4479 0 38.9999 0.447 38.9999 1V6.745C34.8989 3.375 29.8119 1.526 24.4489 1.5C24.4089 1.5 24.3699 1.5 24.3309 1.5C18.2229 1.5 12.4909 3.87 8.17992 8.181C-0.331076 16.692 -0.742077 30.489 7.24492 39.589C7.44292 39.815 7.71892 39.93 7.99692 39.93C8.23092 39.93 8.46592 39.848 8.65592 39.682C9.07092 39.318 9.11192 38.686 8.74792 38.271C1.45392 29.959 1.82592 17.363 9.59392 9.595C13.5519 5.637 18.8179 3.506 24.4389 3.5Z"}}),_c('path',{attrs:{"d":"M44.748 12.403C44.384 11.99 43.751 11.948 43.337 12.312C42.922 12.676 42.881 13.308 43.245 13.723C50.545 22.035 50.176 34.633 42.405 42.405C38.447 46.363 33.188 48.538 27.56 48.5C22.827 48.476 18.338 46.884 14.659 44H21C21.552 44 22 43.553 22 43C22 42.447 21.552 42 21 42H12C11.87 42 11.74 42.026 11.618 42.077C11.373 42.178 11.178 42.373 11.077 42.618C11.026 42.74 11 42.87 11 43V51C11 51.553 11.448 52 12 52C12.552 52 13 51.553 13 51V45.255C17.101 48.625 22.188 50.474 27.551 50.5C27.591 50.5 27.63 50.5 27.669 50.5C33.777 50.5 39.509 48.13 43.82 43.819C52.334 35.305 52.742 21.506 44.748 12.403Z"}})])
          )
        }
      }
    